module.exports = __webpack_public_path__ + "img/toggleGauge.c63d5a27.svg";